import { defineComponent as r, createBlock as a, openBlock as p, normalizeProps as n, guardReactiveProps as s, withCtx as l, renderSlot as m, createElementVNode as u } from "vue";
import d from "../CdrIcon.vue.mjs";
const f = /* @__PURE__ */ r({
  name: "PlusStroke",
  __name: "plus-stroke",
  props: {
    props: {
      type: Object
    }
  },
  setup(t) {
    return (o, e) => (p(), a(d, n(s(t.props)), {
      default: l(() => [m(o.$slots, "default"), e[0] || (e[0] = u("path", {
        role: "presentation",
        d: "M11 11V8a1 1 0 012 0v3h3a1 1 0 010 2h-3v3a1 1 0 01-2 0v-3H8a1 1 0 010-2h3zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
      }, null, -1))]),
      _: 3
    }, 16));
  }
});
export {
  f as default
};
